import StationLocationService from '@/service/StationLocationService';

const initialState = {
    stationLocation: null
}

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async fetchStationLocation({commit}, payload){
            const {probeId, locationId} = payload
            try {
                const resp = await StationLocationService.getStationLocation(probeId, locationId)
                if (!resp) return
                commit('setStationLocation', resp.data)
            }
            catch (e) {
                console.error(e)
            }
        },
        async updateStationLocationVariables({dispatch, commit}, payload) {
            const {probeId, locationId, variables} = payload
            try {
                const resp = await StationLocationService.updateStationLocationVariables(probeId, locationId, variables)
                if (resp.status === 200) {
                    commit('setStationLocationVariables', resp.data.new_variables)
                    await dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Variables updated',
                        type: 'success'
                    }, {root: true})
                } else {
                    await dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Update failed',
                        type: 'error'
                    }, {root: true})
                }
            }
            catch (e) {
                console.error(e)
            }
        }
    },
    mutations: {
        setStationLocation(state, payload) {
            state.stationLocation = payload
        },
        setStationLocationVariables(state, payload) {
            const newVariables = payload
            if (!newVariables) return
            // eslint-disable-next-line no-undef
            const stationLocation = structuredClone(state.stationLocation)
            stationLocation.sensor_variables = newVariables
            state.stationLocation = stationLocation
        }
    },
    getters: {
        getStationLocation(state) {
            return state.stationLocation
        }
    }
}